import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61638282"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "info-top-bar" }

import { ref } from 'vue';
import ReviewModal from '@/components/ReviewModal/ReviewModal.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'InfoTopBar',
  props: {
    text: { default: ' Sed ut perspiciatis, unde omnis iste natus error sit voluptatem accusantium\n' +
      '      doloremque laudantium, totam rem aperiam eaque ipsa, quae ab illo inventore\n' +
      '      veritatis et quasi architecto beatae vitae dicta sunt, explicabo. Nemo enim ipsam\n' +
      '      voluptatem, quia voluptas sit, aspernatur aut odit aut fugit, sed quia consequuntur\n' +
      '      magni dolores eos, qui ratione voluptatem sequi nesciunt, neque porro quisquam est,\n' +
      '      qui dolorem ipsum, quia dolor sit, amet, consectetur, adipisci velit, sed quia non\n' +
      '      numquam eius modi tempora incidunt, ut labore et dolore magnam aliquam quaerat\n' +
      '      voluptatem. Ut enim ad minima veniam' }
  },
  setup(__props: any) {

const props = __props;

const showReviewModal = ref(false);

return (_ctx: any,_cache: any) => {
  const _component_base_button = _resolveComponent("base-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, _toDisplayString(_ctx.text), 1),
      _createVNode(_component_base_button, {
        "all-block-width": "",
        height: "36",
        "style-type": "border",
        text: "Отзыв / предложение",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showReviewModal.value = true))
      })
    ]),
    _createVNode(ReviewModal, {
      "show-modal": showReviewModal.value,
      onClose: _cache[1] || (_cache[1] = ($event: any) => (showReviewModal.value = false))
    }, null, 8, ["show-modal"])
  ], 64))
}
}

})